module.exports = __webpack_public_path__ + "assets/img/ftr-app-1.1a5f5697.png";